export const redirectUserToHome = (user, history) => {
    const userType = user.user?.type || user.type;

    // Todos los perfiles aterrizan en /dashboard: DashboardSwitcher decide que
    // tablero renderizar (el Operador ve ahi "Mis salidas del dia").
    history.push(userType == 2 ? "/provider/daily" : (userType == 3 ? "/client/daily" : "/dashboard"));
}
